import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    setManageTeamMode,
    postTransferTeam,
    postLimitlessTeam,
    setPopupState,
} from './../../actions/FormationActions';
import {
    getUserTeamOfMatchDay,
    createManageTeamSkeleton,
    resetTransfers,
} from './../../actions/ManageTeamActions';
import {
    getInTeamArray,
    getTransfersApiData,
    getState,
    getOrderedPlayerIDs,
} from "../../helper";
import {
    getTeamDeadlineObj
} from "../../helper-common";
import {
    isBoosterTaken,
} from "../../helper-booster";
import config from './../../config';
import common from './../../common';
import ManageTeamStatus from './../manage-team/Manage-Team-Status';
import JerseyManageTeamSummary from './Jersey-Manage-Team-Summary';
import BoosterBtn from './../../components/onboarding/BoosterBtn';
import MoreMenu from './../../components/onboarding/MoreMenu';
import GeneralPopUp from './../GeneralPopUp';
import BoosterPopup from './../BoosterPopup';
import apiError from './../../constants/api-error';
import AdBottom from '../AdBottom';
import Matches from '../matches';
import routeObject from '../../constants/new-pageTrackEvents'

class ManageTeamSummary extends Component {
    getTeam = () => {
        const { userSpecificFixtures, currentActiveFixture } = this.props;
        const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
        const { GDID, PhID } = currentFixture;
        const GUID = common.getGUID();
        const getUserPlayedGameDaysPromise = this.props.getUserTeamOfMatchDay(GUID, GDID, PhID);
        getUserPlayedGameDaysPromise.then(() => {
            common.hideLoader();
            this.props.createManageTeamSkeleton();
        }).catch(reason => {
            common.hideLoader();
        });
    };
    handleNext = (btnType) => {
        if (this.props.manageTeamMode === config.modes["transfer"]) {
            if (btnType === "cancel") {
                this.props.resetTransfers();
                common.pageViewTracking("", routeObject["myTeam"]);
                this.props.setManageTeamMode(config.modes["view-manage-team"]);
            } else if (btnType === "next") {
                // common.customTracking('Transfers - Next');
                this.props.setManageTeamMode(config.modes["transfer-summary"]);
                return this.props.history.push('/transfer-summary');
            }
        } else if (this.props.manageTeamMode === config.modes["transfer-summary"]) {
            if (btnType === "confirm") {
                common.customTracking('Transfers - Confirm', '/uclfantasy/my-team/transfers/summary/');
                this.confirmTransfer();

            } else if (btnType === "cancel") {
                this.setPopupStateObj({
                    showPopup: true,
                    message: this.props.trans["changesWarning"],
                    wrapperClasses: 'si-popup-warning',
                    secondaryBtnText: this.props.trans["discard"],
                    primaryBtnText: this.props.trans["keep"],
                    secondaryBtnHandler: this.confirmCancel,
                    primaryBtnHandler: this.resetToast,
                    iconClass: 'icon-ucl-warning-icon'
                });
            } else if (btnType === "confirmCancel") {
                // common.pageViewTracking("", routeObject["myTeam"]);
                this.props.resetTransfers();
                // common.customTracking('Transfers - Discard Confirm');
                this.resetToast();
                this.props.setManageTeamMode(config.modes["view-manage-team"]);
            }
        }
    };
    confirmTransfer = () => {
        if (this.props.manageTeamMode === config.modes["transfer-summary"]) {
            /* transfer post api data starts */
            common.showLoader();
            const { userSpecificFixtures, currentActiveFixture, teamData, defaultFormation, manageTeamRawData } = this.props;
            if (userSpecificFixtures.length === 0) return null;
            let isLimitlessSelected = isBoosterTaken('IsBoosterOneTaken', teamData, userSpecificFixtures, currentActiveFixture);
            const GUID = common.getGUID();
            const selectedMatchDay = userSpecificFixtures[currentActiveFixture];
            const playersTransfer = getTransfersApiData(manageTeamRawData, teamData);
            const OBJ = {};
            let postApiName = "postTransferTeam";
            let postApiReducerObj = "savedTransferData";
            if (isLimitlessSelected && (+teamData.IsBoosterOneTaken !== 1)) {
                postApiName = "postLimitlessTeam";
                postApiReducerObj = "savedLimitlessData";
                OBJ.OptType = 1;
                OBJ.Platform = config.PLATFORM_ID;
                OBJ.GamedayId = selectedMatchDay['GDID'];
                OBJ.PhaseId = selectedMatchDay['PhID'];
                OBJ.CaptainId = teamData.captainID;
                OBJ.BoosterId = 1;
                OBJ.InPlayerId = getOrderedPlayerIDs(teamData);
                OBJ.InPlayerBenchPosition = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 3, 4];
                OBJ.GDCompId = 9;
                OBJ.MDCompId = defaultFormation.CompId;
                OBJ.LangCode = config.CURRENT_LANGUAGE;
            } else {
                let isWildCardSelected = isBoosterTaken('IsWildCardTaken', teamData, userSpecificFixtures, currentActiveFixture);
                OBJ.OptType = 1;
                OBJ.Platform = config.PLATFORM_ID;
                OBJ.GamedayId = selectedMatchDay['GDID'];
                OBJ.PhaseId = selectedMatchDay['PhID'];
                OBJ.CaptainId = teamData.captainID;
                OBJ.IsWildcard = (isWildCardSelected && (+teamData.IsWildCardTaken !== 1)) ? 1 : teamData.IsWildCardTaken;
                OBJ.InPlayerId = playersTransfer.InPlayerId;
                OBJ.InPlayerBenchPosition = playersTransfer.InPlayerBenchPosition;
                OBJ.OutPlayerId = playersTransfer.OutPlayerId;
                OBJ.OutPlayerBenchPosition = playersTransfer.OutPlayerBenchPosition;
                OBJ.SubPlayerId = [];
                OBJ.SubPlayerBenchPosition = [];
                OBJ.GDCompId = 9;
                OBJ.MDCompId = defaultFormation.CompId;
                OBJ.ISMCPR = 0;
                OBJ.IsNewsletter = 0;
                OBJ.LangCode = config.CURRENT_LANGUAGE;
                OBJ.BadgeId = 0;
                OBJ.FavTeamId = 0;
                OBJ.TeamName = "";
            }
            /* transfer post api data ends */

            //change or compare captain

            let keysToConsider = ['4', '3', '2', '1'];
            let captainId = ""
            keysToConsider.forEach((positionKey) => {
                teamData[positionKey].forEach((player, jIndex) => {
                    if (player.isCaptain == true) {
                        captainId = player.id
                    }
                });
            });
            if (captainId != teamData.captainID) {
                OBJ.CaptainId = captainId;
            }

            this.props[postApiName](GUID, OBJ)
                .then(() => {
                    const { response } = this.props[postApiReducerObj];
                    const retVal = response.Meta['RetVal'];
                    const messageTrans = apiError.transfers[retVal];
                    const message = this.props.trans[messageTrans];
                    if (response.Meta['Success'] && retVal === 1) {

                        this.props.setManageTeamMode(config.modes["view-manage-team"]);
                        /* this.setPopupStateObj({
                            showPopup: true,
                            message: this.props.trans["showOff"],
                            title: this.props.trans["saved"],
                            wrapperClasses: 'si-success-popup',
                            secondaryBtnText: this.props.trans["notNow"],
                            primaryBtnText: this.props.trans["share"],
                            secondaryBtnHandler: this.resetToast,
                            primaryBtnHandler: this.resetToast,
                            iconClass: 'icon-ucl-tick'
                        }); */
                        this.setPopupStateObj({
                            showPopup: true,
                            isToast: true,
                            message: message,
                            wrapperClasses: 'si-warning-toast si-success-popup',
                            iconClass: 'icon-ucl-tick',
                            resetToast: this.resetToast
                        });
                        common.customTracking('Transfers - Confirm', '/uclfantasy/my-team/transfers/summary/');
                        this.getTeam();
                        return this.props.history.push('/manage-team');
                    } else {
                        common.hideLoader();
                        this.setPopupStateObj({
                            showPopup: true,
                            isToast: true,
                            message: message,
                            wrapperClasses: 'si-warning-toast si-error-popup',
                            iconClass: 'icon-ucl-warning-icon',
                            resetToast: this.resetToast
                        });
                        if (retVal === 1001) {
                            common.updateBusters('/bust-after-status-change');
                            const url = config.BASE_DIR + '/manage-team';
                            window.location.replace(url);
                        }
                    }
                });
        }
    };
    resetToast = () => {
        let bodyElem = document.body;
        bodyElem.classList.remove('bodyNoScroll');
        this.props.setPopupState({ showPopup: false, message: '' });
    };
    confirmCancel = () => {
        this.handleNext("confirmCancel");
    };
    setPopupStateObj = (obj) => {
        let bodyElem = document.body;
        bodyElem.classList.add('bodyNoScroll');
        this.props.setPopupState(obj);
    };
    getDeadlineStatusText = () => {
        const { trans, constraints } = this.props;
        let deadlineObj = {};
        const lockTime = this.props.deadline;
        if (lockTime) {
            deadlineObj = getTeamDeadlineObj(trans, constraints.OffSet, lockTime);
        } else {
            const { userSpecificFixtures, currentActiveFixture } = this.props;
            const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
            let getViewState = "";
            if (currentFixture) {
                getViewState = getState(currentFixture);
                deadlineObj = getTeamDeadlineObj(trans, constraints.OffSet, currentFixture.Deadline, getViewState);
            }
        }
        return <div className="si-subs-status">
            { deadlineObj.isLockIcon ? <i className="icon-ucl-lock" /> : null }
            { deadlineObj.deadlineText ? deadlineObj.deadlineText : null }
        </div>
    };

    render() {
        const { budget, teamData, manageTeamRawData, manageTeamMode, userSpecificFixtures, currentActiveFixture, boosterPopupState } = this.props;
        const { IsAccounting, SubsNegativePoints, SubstitutionsLeft, SubstitutionsAllowed } = teamData;
        let transferredIn = [];
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-manage-team': true,
            'si-no-anim': true,
            'si-trf-summary': true
        });
        let si_val = '';
        let boosterTaken = false;
        let limitlessBudget = false;
        let hideAutocomplete = false;
        if (manageTeamMode === config.modes["transfer-summary"]) {
            transferredIn = getInTeamArray(teamData, manageTeamRawData);
            let isWildCardSelected = isBoosterTaken('IsWildCardTaken', teamData, userSpecificFixtures, currentActiveFixture);
            let isLimitlessSelected = isBoosterTaken('IsBoosterOneTaken', teamData, userSpecificFixtures, currentActiveFixture);
            boosterTaken = (isWildCardSelected || isLimitlessSelected);
            limitlessBudget = isLimitlessSelected;
            hideAutocomplete = isLimitlessSelected;
        }
        if (!(transferredIn.length > 0)) {
            return <Redirect push to={ '/manage-team' } />
        }
        let additionalPoints = <div className="si-points">0 (0 { this.props.trans.labelPts })</div>;
        if (+IsAccounting === 0 || boosterTaken) {
            si_val = <div className="si-val">
                <div className="si-infinity-icon">∞</div>
            </div>
        } else if (+IsAccounting === 1) {
            const subsLeft = transferredIn.length > 0 ? (SubstitutionsLeft - transferredIn.length) : SubstitutionsLeft;
            if (subsLeft < 0) {
                const negativePoints = (SubsNegativePoints * subsLeft);
                si_val = <div className="si-val">
                    <span className="si-count">{ SubstitutionsAllowed }</span>
                </div>;
                additionalPoints = <div className="si-points" style={ { 'color': 'red' } }>{ -subsLeft }
                    ({ negativePoints } { this.props.trans.labelPts })</div>
            } else {
                si_val = <div className="si-val">
                    <span className="si-count">{ SubstitutionsAllowed }</span>
                </div>;
            }
        }
        const { showPopup, isToast, message, title, wrapperClasses, secondaryBtnText, primaryBtnText, secondaryBtnHandler, primaryBtnHandler, iconClass, resetToast } = this.props.popupState;
        if (!showPopup) {
            let bodyElem = document.body;
            bodyElem.classList.remove('bodyNoScroll');
        }
        const popupProps = {
            showPopup,
            isToast,
            message,
            title,
            secondaryBtnText,
            primaryBtnText,
            secondaryBtnHandler,
            primaryBtnHandler,
            iconClass,
            resetToast,
            wrapperClass: wrapperClasses
        };
        let deadlineStatus = this.getDeadlineStatusText();
        return (<React.Fragment>
            <div className={ wrapperClass }>
                <div className="si-container">
                    <div className="si-top-section">
                        { manageTeamMode !== config.modes["view-manage-team"] ?
                            <ManageTeamStatus handleNext={ this.handleNext.bind(this) } { ...{ hideAutocomplete } } /> : null }
                    </div>
                    <div className="si-common-menu si-web-menu">
                        <MoreMenu />
                    </div>
                    <div className="si-summary-container">
                        <div className="si-transfer-history">
                            <div className="si-header-txt">
                                <div className="si-plyr-out">
                                    <span>{ this.props.trans.out }</span>
                                    <i className="si-subs-out-icon icon-ucl-substitute-out" />
                                </div>
                                <div className="si-plyr-in">
                                    <i className="si-subs-in-icon icon-ucl-substitute-in" />
                                    <span>{ this.props.trans.in }</span>
                                </div>
                            </div>
                            <div className="si-transfer-body">
                                {
                                    transferredIn.map(function (pIn, index) {
                                        let inPlayer = transferredIn[index];
                                        return (<JerseyManageTeamSummary key={ index } player={ inPlayer } />)
                                    })
                                }
                            </div>
                        </div>
                        <div className="si-summary-booster">
                            <span className="si-confirm-txt">{ this.props.trans.playBooster }</span>
                            <div className="si-booster-wrap">
                                <BoosterBtn />
                            </div>
                        </div>
                        <div className="si-transfer-stats">
                            <div className="si-stats-header">
                                <span>{ this.props.trans.summary }</span>
                            </div>
                            <div className="si-stats-body">
                                <div className="si-stats-wrap">
                                    <div className="si-transfer-info">{ this.props.trans.freeTransfer }</div>
                                    { si_val }
                                </div>
                                <div className="si-stats-wrap">
                                    <div className="si-transfer-info">{ this.props.trans.additionalTransfer }</div>
                                    { additionalPoints }
                                </div>
                                <div className="si-stats-wrap">
                                    <div className="si-transfer-info">{ this.props.trans.remainBudget }</div>
                                    {
                                        limitlessBudget ?
                                            <div className="si-infinity-icon">∞</div> :
                                            (budget < 0) ?
                                                <div className="si-points" style={ { 'color': 'red' } }>
                                                    €{ budget }{ this.props.trans.million }</div> :
                                                <div className="si-points">€{ budget }{ this.props.trans.million }</div>
                                    }
                                </div>
                            </div>
                        </div>
                        { deadlineStatus }
                        <div className="si-btn-wrp">
                            <div className="si-btn si-btn-primary" onClick={ () => this.confirmTransfer() }>
                                <span>{ this.props.trans.confirm }</span>
                            </div>
                        </div>
                    </div>
                    <AdBottom />
                    <GeneralPopUp { ...popupProps } />
                    { boosterPopupState.showBoosterPopup ? <BoosterPopup { ...boosterPopupState } /> : null }
                </div>
            </div>
            {
                (!config.isMobile)
                    ?
                    <Matches { ...this.props } />
                    :
                    null
            }
        </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        constraints: state.appData.constraints,
        trans: state.appData.trans,
        budget: state.formationData.teamData.budget,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
        teamData: state.formationData.teamData,
        manageTeamRawData: state.formationData.manageTeamRawData,
        manageTeamMode: state.formationData.manageTeamMode,
        defaultFormation: state.formationData.defaultFormation,
        savedTransferData: state.formationData.savedTransferData,
        savedLimitlessData: state.formationData.savedLimitlessData,
        popupState: state.formationData.popupState,
        boosterPopupState: state.formationData.boosterPopupState,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getUserTeamOfMatchDay: (guid, gamedayId, phaseId) => dispatch(getUserTeamOfMatchDay(guid, gamedayId, phaseId)),
        createManageTeamSkeleton: (constraints) => dispatch(createManageTeamSkeleton(constraints)),
        setManageTeamMode: (mode) => dispatch(setManageTeamMode(mode)),
        resetTransfers: () => dispatch(resetTransfers()),
        getInTeamArray: (teamData, oldTeamData) => dispatch(getInTeamArray(teamData, oldTeamData)),
        postTransferTeam: (GUID, obj) => dispatch(postTransferTeam(GUID, obj)),
        setPopupState: (obj) => dispatch(setPopupState(obj)),
        postLimitlessTeam: (GUID, obj) => dispatch(postLimitlessTeam(GUID, obj)),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageTeamSummary));


// WEBPACK FOOTER //
// ./src/components/manage-team/Manage-Team-Summary.js